export enum OperationType {
    'Вывод средств',
    'Возграждение за свою продажу',
    'Вознаграждение за продажу друга',
    'Пассивный доход',
}

export enum OperationTypeIcons {
    withdrawal_success = 0,
    drugomaniya = 2,
}
